module.exports = __webpack_public_path__ + "static/media/add1.58429641.jpg";